import type { TFunction } from 'i18next'

import { formatDateToString, formatMoneyV2 } from '~/helpers'

import type { WalletBalanceOriginRow } from './types'

import styles from './styles.module.css'

type OriginsSchemaOptions = {
  remaining: boolean
  t: TFunction
}

export const createOriginsSchema = ({
  remaining,
  t
}: OriginsSchemaOptions): TableSchema<WalletBalanceOriginRow> => ({
  origin: {
    title: t('rm:wallet.balanceOrigin.column.origin'),
    width: '40%',
    render: row => {
      const originName =
        row.kind === 'pi'
          ? row.name
          : (row.name ?? t('rm:wallet.balanceOrigin.preexisting.name'))
      const originCaption = row.kind === 'pi' ? row.id : null

      return (
        <div className={styles.originCell}>
          <span className={styles.originName}>{originName}</span>
          {originCaption ? (
            <span className={styles.originCaption}>{originCaption}</span>
          ) : null}
        </div>
      )
    }
  },
  total: {
    title: t('rm:wallet.balanceOrigin.column.total'),
    className: 'text-end',
    classNameTD: 'text-end',
    render: row => formatMoneyV2({ value: row.total })
  },
  consumed: {
    title: t('rm:wallet.balanceOrigin.column.consumed'),
    className: 'text-end',
    classNameTD: 'text-end',
    render: row =>
      row.kind === 'preexisting' && row.consumed === 0
        ? '—'
        : formatMoneyV2({ value: row.consumed })
  },
  available: {
    title: remaining
      ? t('rm:wallet.balanceOrigin.column.remaining')
      : t('rm:wallet.balanceOrigin.column.available'),
    className: 'text-end',
    classNameTD: 'text-end',
    render: row => formatMoneyV2({ value: row.available })
  },
  expiresAt: {
    title: remaining
      ? t('rm:wallet.balanceOrigin.column.expiredAt')
      : t('rm:wallet.balanceOrigin.column.expiresAt'),
    className: 'text-end',
    classNameTD: 'text-end',
    render: row =>
      row.expiresAt ? formatDateToString(row.expiresAt, 'DD/MM/YYYY') : '—'
  }
})
